<template>
  <div class="">
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>

      <div class="col-auto">
        <button
          @click="$router.push({ name: 'services-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un nouveau produit
        </button>
      </div>

      <div class="col-auto">
        <button @click="printAll()" class="btn btn-secondary">
          <i class="bi bi-printer"></i>
          Imprimer
        </button>
      </div>
    </div>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Catégorie</th>
          <th scope="col">Unité</th>
          <th scope="col">Prix TTC</th>
          <th scope="col">TVA</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(service, index) in services" :key="index++">
          <td>
            {{ index }}
          </td>
          <td class="p-0 m-0">
            {{ service.reference }}
          </td>
          <td>
            {{ service.fullName }}
          </td>

          <td>
            <span v-if="service.section">
              {{ service.section.fullName }}
            </span>
          </td>

          <td>
            {{ service.measuring }}
          </td>

          <td>
            {{ parseFloat(service.priceTTC).toFixed(2) }}
          </td>

          <td>{{ service.tva }} %</td>

          <td class="d-flex">
            <button
              @click="
                $router.push({
                  name: 'services-edit',
                  params: {
                    reference: service.reference,
                  },
                })
              "
              class="btn"
            >
              <i class="bi bi-pencil-square"></i>
            </button>
            <button @click="remove(service)" class="btn">
              <i class="bi bi-trash text-danger"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
    };
  },
  computed: {
    ...mapGetters("service", {
      services: "getServices",
    }),
    // imageUrl() {
    //   return (service) => `${service.image}`
    // },
  },
  mounted() {
    this.$store.dispatch("service/getAll");
  },
  methods: {
    async search(value) {
      return await this.$store.commit("service/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("service/getAll");
    },

    async sort(value) {
      return await this.$store.commit("service/sort", value);
    },

    async remove(data) {
      let service = data;
      await this.$confirm({
        message: "Vous voulez supprimer l'article  " + service.fullName,
        button: {
          no: "Non",
          yes: "Oui",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("service/destroy", service.reference);
          }
        },
      });
    },

    async printAll() {
      return await this.$store.dispatch("service/printAll");
    },
  },
};
</script>
